module.exports = __webpack_public_path__ + "static/media/img-horizontal-buildings.04087bb7.png";